import { createSlice } from "@reduxjs/toolkit";
const initValue = {
  sckCommand: {
    ReqCommand: "",
    DestSessionType: 0,
    DestStaff: 0,
    SrcSessionType: 0,
    SrcStaff: 0,
    StudyID: 0,
    TargetStaff: 0,
    TicketID: 0,
    UserID: 0,
    PatientName: "",
    StudyInstanceUid: "",
  },
  reminderStatus: { show: true, message: "Welcome!", type: "success" },
  onlineInfo: { online: false, sessionId: null },
  enableMouseEvent: { mousedown: false } /** อนุญาติ เมื่อดับเบิ้ลคลิก */,
  sckFunction: {},
};

const userSlice = createSlice({
  name: "user",
  initialState: initValue,
  reducers: {
    setMessage: (state, action) => {
      state.detail = action.payload;
    },
    setReminder: (state, action) => {
      state.reminderStatus = action.payload;
    },
    setOnlineState: (state, action) => {
      state.onlineInfo = { ...state.onlineInfo, ...action.payload };
    },
    setSocketFunction: (state, action) => {
      //console.log("it is ", action.payload);
      state.sckFunction = action.payload;
    },
    enableMouseEvent: (state, action) => {
      console.log(action.payload);
      state.enableMouseEvent = action.payload;
    },
  },
});

const { actions, reducer } = userSlice;

export const {
  setMessage,
  setReminder,
  setOnlineState,
  setSocketFunction,
  enableMouseEvent,
} = actions;

export default reducer;
